import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const TopPromptsTable = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Paper sx={{ p: 4, boxShadow: 3, borderRadius: 4, mb: 4 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography color="text.secondary">No data available</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        p: 3,
        boxShadow: 3,
        borderRadius: 4,
        mb: 4,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
          fontWeight: 600,
          color: 'text.primary',
        }}
      >
        Top 10 Tools/Prompts by Usage
      </Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="top prompts table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Rank</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Tool/Prompt Name</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>
                Usage Count
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((prompt, index) => (
              <TableRow
                key={prompt.promptId}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell>{prompt.promptName || "Unknown"}</TableCell>
                <TableCell align="right">{prompt.count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TopPromptsTable;

